<template>
  <v-container fill-height>
    <v-layout
      align-center
      justify-center
      fill-height
    >
      <v-flex
        shrink
        style="margin-top:-200px"
      >
        <div class="text-404">
          404
        </div>
        <div class="text-center headlinex">
          Opps! That page does not seem to exist
        </div>
        <div class="text-center mt-8">
          <v-btn
            color="primary"
            large
            to="/"
            replace
          >
            Take me home
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import renderReady from '@/mixins/render-ready'

export default {
  mixins: [ renderReady ]
}
</script>

<style>
.text-404{
    font-size: 12rem;
    text-align: center;
    font-weight: 700;
    opacity: .5;
}
</style>
